













































































import { Component, Prop, Model, Watch, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { randomId } from "@/utils";
import moment from "moment";
import DatePicker from "vuejs-datepicker";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class DatePopover extends Vue {
  @Model("changed") readonly modelDate!: any;
  @Prop(String) readonly title!: string;
  id = "date-popover";
  target = `date-popover-target-${randomId(6)}`;
  date = null;
  show = false;
  @Watch("modelDate")
  onModelChanged() {
    this.date = this.modelDate;
  }
  shown() {
    this.date = this.modelDate;
    this.$emit("shown");
  }
  save(date) {
    this.$emit("changed", moment(date).format("YYYY-MM-DD"));
    this.close();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  get formattedDate() {
    if (this.date) {
      return moment(this.date).format("MMM D, YYYY");
    }
    return null;
  }
  mounted() {
    this.shown();
  }
}
